export default __webpack_public_path__ + "static/hero-image-bca386fdb475563f14eebf8e1c13686b.jpg";